import {
  Component,
  OnInit,
  Input,
  OnChanges,
  ChangeDetectorRef
} from '@angular/core';
import {
  StepResponse,
  OtherCoverageDetails,
  StepsService,
  GlobalVariablesService,
  SummaryMapperService
} from '@tmhcc-ng-lib/data-service';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { trigger, style, animate, transition } from '@angular/animations';
import { has } from 'libs/util/has-value';
import { ProductType, SummaryUrl, ProductStepsUrl } from '@tmhcc-ng-lib/models';
import { SummaryContentService } from '@tmhcc-ng-lib/content-service';

@Component({
  selector: 'ae-general-info-tabs',
  animations: [
    trigger('summaryAccordian', [
      transition(':enter', [
        style({ opacity: 0, height: 0 }),
        animate('0.5s ease-in', style({ opacity: 1, height: '*' }))
      ]),
      transition(':leave', [
        style({ opacity: 1, height: '*' }),
        animate('0.5s ease-out', style({ opacity: 0, height: 0 }))
      ])
    ])
  ],
  templateUrl: './general-info-tabs.component.html',
  styleUrls: ['./general-info-tabs.component.scss']
})
export class GeneralInfoTabsComponent implements OnInit, OnChanges {
  tab1: string;
  tab2: string;
  tab3: string;
  tab4: string;
  summaryPanel: StepResponse;
  summaryContent;
  summaryTab;
  prodName: string;
  isEnPending = false;
  @Input() summarySitecoreData;
  @Input() summaryApiData;
  @Input() pageName;
  @Input() boundSitecoreData;

  constructor(
    private loaderService: LoaderService,
    private cdRef: ChangeDetectorRef,
    private stepsService: StepsService,
    private globalVarService: GlobalVariablesService,
    private summaryMapperService: SummaryMapperService,
    private summaryContentService: SummaryContentService
  ) {}
  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  ngOnChanges() {
    this.summaryPanel = this.summaryApiData;
    this.prodName = this.globalVarService.productName;
    this.populateSummaryInfo();
  }
  enPendingSummaryTab(summaryTab) {
    if (!summaryTab) return summaryTab;
    if (
      location.pathname.includes('enpolicysnapshot') ||
      location.pathname.includes('enpolicyinformation') ||
      location.pathname.includes('encoverage')
    ) {
      this.isEnPending = true;
      let tabs = summaryTab.menu.filter(
        item => item.name != 'General Liability Coverage'
      );
      summaryTab.menu = tabs;
      return summaryTab;
    }
    return summaryTab;
  }
  declineGLSummaryTab(summaryTab) {
    if (!summaryTab) return summaryTab;
    if (location.pathname.includes('declined')) {
      let tabs = summaryTab.menu.filter(
        item =>
          item.name != 'Payment' && item.name != 'General Liability Coverage'
      );
      summaryTab.menu = tabs;
      return summaryTab;
    }
    return summaryTab;
  }
  declineBRSummaryTab(summaryTab) {
    if (!summaryTab) return summaryTab;
    if (location.pathname.includes('declined')) {
      let tabs = summaryTab.menu.filter(
        item => item.name != 'Payment' && item.name != 'Builders Risk Coverage'
      );
      summaryTab.menu = tabs;
      return summaryTab;
    }
    return summaryTab;
  }
  declinePLSummaryTab(summaryTab) {
    if (!summaryTab) return summaryTab;
    if (location.pathname.includes('declined')) {
      let tabs = summaryTab.menu.filter(
        item =>
          item.name != 'Payment' && item.name != 'Pollution Liability Coverage'
      );
      summaryTab.menu = tabs;
      return summaryTab;
    }
    return summaryTab;
  }
  declinePRSummaryTab(summaryTab) {
    if (!summaryTab) return summaryTab;
    if (location.pathname.includes('declined')) {
      let tabs = summaryTab.menu.filter(
        item =>
          item.name != 'Payment' &&
          item.name != 'Professional Liability Coverage'
      );
      summaryTab.menu = tabs;
      return summaryTab;
    }
    return summaryTab;
  }
  declineEXSummaryTab(summaryTab) {
    if (!summaryTab) return summaryTab;
    if (location.pathname.includes('declined')) {
      let tabs = summaryTab.menu.filter(
        item =>
          item.name != 'Payment' && item.name != 'Excess Liability Coverage'
      );
      summaryTab.menu = tabs;
      return summaryTab;
    }
    return summaryTab;
  }
  declineCESummaryTab(summaryTab) {
    if (!summaryTab) return summaryTab;
    if (location.pathname.includes('declined')) {
      let tabs = summaryTab.menu.filter(
        item =>
          item.name != 'Payment' &&
          item.name != 'Contractors Equipment Coverage'
      );
      summaryTab.menu = tabs;
      return summaryTab;
    }
    return summaryTab;
  }
  removeInspectionTab(summaryTab) {
    if (!summaryTab) return summaryTab;

    let tabs = summaryTab.menu.filter(
      item => item.name != 'Inspection Information'
    );
    summaryTab.menu = tabs;
    return summaryTab;
  }
  populateSummaryInfo() {
    if (
      this.globalVarService.productName == ProductType.General &&
      this.pageName == ProductStepsUrl.Bound
    ) {
      this.summaryContent = this.summarySitecoreData?.summaryPanel.find(
        item => {
          return item.name == SummaryUrl.BoundGeneral;
        }
      );
      if (
        has(this.summaryPanel, 'InspectionDetails.HasInspection') &&
        !this.summaryPanel.InspectionDetails?.HasInspection
      ) {
        this.summaryContent = this.removeInspectionTab(this.summaryContent);
        this.summaryContentService.loadFromCache = false;
      }
    } else {
      switch (this.globalVarService.productName) {
        case ProductType.General:
          this.summaryContent = this.summarySitecoreData?.summaryPanel.find(
            item => {
              return item.name == SummaryUrl.General;
            }
          );
          this.summaryContent = this.declineGLSummaryTab(this.summaryContent);
          this.summaryContent = this.enPendingSummaryTab(this.summaryContent);
          break;
        case ProductType.Pollution:
          this.summaryContent = this.summarySitecoreData?.summaryPanel.find(
            item => {
              return item.name == SummaryUrl.Pollution;
            }
          );
          this.summaryContent = this.declinePLSummaryTab(this.summaryContent);
          break;
        case ProductType.Professional:
          this.summaryContent = this.summarySitecoreData?.summaryPanel.find(
            item => {
              return item.name == SummaryUrl.Professional;
            }
          );
          this.summaryContent = this.declinePRSummaryTab(this.summaryContent);
          break;
        case ProductType.Builders:
          this.summaryContent = this.summarySitecoreData?.summaryPanel.find(
            item => {
              return item.name == SummaryUrl.BUilders;
            }
          );
          this.summaryContent = this.declineBRSummaryTab(this.summaryContent);
          break;
        case ProductType.Excess:
          this.summaryContent = this.summarySitecoreData?.summaryPanel.find(
            item => {
              return item.name == SummaryUrl.Excess;
            }
          );
          this.summaryContent = this.declineEXSummaryTab(this.summaryContent);
          break;
        case ProductType.Contractors:
          this.summaryContent = this.summarySitecoreData?.summaryPanel.find(
            item => {
              return item.name == SummaryUrl.Contractors;
            }
          );
          this.summaryContent = this.declineCESummaryTab(this.summaryContent);
          break;
      }
    }

    let defaultOtherCoverages = [
      { Name: 'Excess', Limits: [{ Value: 'Not Quoted' }] },
      { Name: 'Contractors Personal Property', CoverageOption: 'Not Quoted' }
    ];

    let premiumDetailsCoverages = [
      { Name: 'Excess', Amount: 'Not Quoted' },
      { Name: 'Contractors Personal Property', Amount: 'Not Quoted' }
    ];

    if (this.summaryApiData && this.prodName === ProductType.General) {
      defaultOtherCoverages.forEach(_coverage => {
        if (
          has(this.summaryApiData, 'OtherCoverageDetails') &&
          this.summaryApiData.OtherCoverageDetails.CoverageItems.length >= 0
        ) {
          let resultItem = this.summaryApiData.OtherCoverageDetails.CoverageItems.find(
            otherCoverage => otherCoverage.Name === _coverage.Name
          );
          if (!resultItem) {
            this.summaryApiData.OtherCoverageDetails.CoverageItems.push(
              _coverage
            );
          }
        }
      });
    }

    if (this.summaryApiData && this.prodName === ProductType.General) {
      premiumDetailsCoverages.forEach(_coverage => {
        if (
          has(this.summaryApiData, 'PremiumDetails') &&
          this.summaryApiData.PremiumDetails.PremiumItems.length >= 0
        ) {
          let resultItem = this.summaryApiData.PremiumDetails.PremiumItems.find(
            otherCoverage => otherCoverage.Name === _coverage.Name
          );
          if (!resultItem) {
            this.summaryApiData.PremiumDetails.PremiumItems.push(_coverage);
          }
        }
      });
    }
  }
}
